export default "__VITE_ASSET__EEyDoWHd__"